interface StatCardProps {
  label: string;
  value: string;
  hint?: string;
  tone?: 'default' | 'positive' | 'negative';
}

const TONE_CLASSES: Record<NonNullable<StatCardProps['tone']>, string> = {
  default: 'text-[rgb(var(--text))]',
  positive: 'text-success',
  negative: 'text-error',
};

export function StatCard({ label, value, hint, tone = 'default' }: StatCardProps) {
  return (
    <div className="card p-5">
      <p className="text-xs font-medium uppercase tracking-wider text-[rgb(var(--text-muted))]">{label}</p>
      <p className={`mt-2 font-display text-2xl font-bold tracking-tight ${TONE_CLASSES[tone]}`}>{value}</p>
      {hint ? <p className="mt-1 text-xs text-[rgb(var(--text-muted))]">{hint}</p> : null}
    </div>
  );
}
